import type { RouteRecordRaw } from 'vue-router';
import { useAdminNavStore } from '@/modules/admin/stores/admin-nav';
import { navItems } from './nav';

const setNavItems = () => {
  const store = useAdminNavStore();
  store.navItems = navItems;
};

export const adminReadingPlansListRoute: RouteRecordRaw = {
  path: `/admin/reading-plans`,
  name: 'adminReadingPlansList',
  redirect: {
    name: 'adminReadingPlans',
  },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminReadingPlansRoute: RouteRecordRaw = {
  path: `/admin/reading-plans/list`,
  component: () => import('@/modules/admin-reading-plans/views/ReadingPlans.vue'),
  name: 'adminReadingPlans',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminReadingPlanVideosRoute: RouteRecordRaw = {
  path: `/admin/reading-plans/videos`,
  component: () => import('@/modules/admin-reading-plans/views/BackgroundVideos.vue'),
  name: 'readingPlanVideos',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminReadingPlanAudioRoute: RouteRecordRaw = {
  path: `/admin/reading-plans/audio`,
  component: () => import('@/modules/admin-reading-plans/views/BackgroundAudio.vue'),
  name: 'readingPlanAudio',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminReadingPlanCategoriesRoute: RouteRecordRaw = {
  path: `/admin/reading-plans/categories`,
  component: () => import('@/modules/admin-reading-plans/views/Categories.vue'),
  name: 'readingPlanCategories',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminReadingPlanFeedbacksRoute: RouteRecordRaw = {
  path: `/admin/reading-plans/feedbacks`,
  component: () => import('@/modules/admin-reading-plans/views/Feedbacks.vue'),
  name: 'readingPlanFeedbacks',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};
